goog.provide("shadow.js.shim.module$$mui$material$Pagination");
goog.provide("module$shadow_js_shim_module$$mui$material$Pagination");
shadow.js.shim.module$$mui$material$Pagination = shadow.js.nativeProvides["@mui/material/Pagination"] = shadow$bridge("@mui/material/Pagination");
module$shadow_js_shim_module$$mui$material$Pagination.default = shadow.js.shim.module$$mui$material$Pagination;
